import type { JobSalary } from "@lossdog/job-watchlists";
import { useSignals } from "@preact/signals-react/runtime";

interface Props {
  className?: string;
  liquidity?: number;
  jobSalary?: JobSalary;
}

export default function Liquidity({ className, liquidity, jobSalary }: Props) {
  useSignals();
  const value = jobSalary?.liquidity.value ?? liquidity ?? 0;
  if (Number.isNaN(value) || value <= 0) {
    return <div className={className} />;
  }
  return <div className={className}>{value}</div>;
}
